export default "/images/framework/HalfPinkBg.c41695ea.svg?c41695ea";